<script setup lang="ts">
// Renders comparison copy with inline [label](url) links, without v-html.
// Internal paths become NuxtLinks; external URLs open in a new tab and are
// nofollowed (they usually point at a competitor).
const props = defineProps<{
  text: string
}>()

const parts = computed(() => {
  const out: { text: string, to?: string, external?: boolean }[] = []
  let last = 0
  for (const match of props.text.matchAll(/\[([^\]]+)\]\(([^)\s]+)\)/g)) {
    const index = match.index ?? 0
    if (index > last) out.push({ text: props.text.slice(last, index) })
    const to = match[2]!
    out.push({ text: match[1]!, to, external: /^https?:\/\//.test(to) })
    last = index + match[0].length
  }
  if (last < props.text.length) out.push({ text: props.text.slice(last) })
  return out
})
</script>

<template>
  <template
    v-for="(part, i) in parts"
    :key="i"
  >
    <ULink
      v-if="part.to"
      raw
      :to="part.to"
      :target="part.external ? '_blank' : undefined"
      :rel="part.external ? 'nofollow noopener' : undefined"
      class="font-medium text-primary underline decoration-primary/30 underline-offset-4 hover:decoration-primary"
    >
      {{ part.text }}
    </ULink>
    <template v-else>
      {{ part.text }}
    </template>
  </template>
</template>
